module.exports = __webpack_public_path__ + "media/images/weather/53_night_g-f28b55ea51fec5675f4ec1ec8fa73f4d.png";